//------------------------------------------------Start-------------------------------------------------------------------
//---------------------------- JS for the Shop Tyres & Wheels section ----------------------------------------------------
//------------------------------------------------------------------------------------------------------------------------

const RECAPTCHA_SITE_KEY = '6Ld1T7UrAAAAAAxEci1yYN5mfnGegaic9zngq6-V';
const TOKEN_TTL_MS = 120_000;          // Google says tokens are short-lived (~2 min)
const REFRESH_THRESHOLD_MS = 110_000;  // refresh a bit before hard expiry

let recaptchaToken = null;
let recaptchaFetchedAt = 0;
let inFlightTokenPromise = null;       // avoid duplicate requests

// --- load + execute helpers ---
function loadRecaptcha() {
  return new Promise((resolve, reject) => {
    if (window.grecaptcha) return resolve();
    const s = document.createElement('script');
    s.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(RECAPTCHA_SITE_KEY)}`;
    s.async = true;
    s.defer = true;
    s.onload = resolve;
    s.onerror = () => reject(new Error('reCAPTCHA failed to load'));
    document.head.appendChild(s);
  });
}

async function getRecaptchaToken(action = 'rego_check') {
  await loadRecaptcha();
  await new Promise(res => grecaptcha.ready(res));
  const token = await grecaptcha.execute(RECAPTCHA_SITE_KEY, { action });
  recaptchaToken = token;
  recaptchaFetchedAt = Date.now();
  return token;
}

// Returns a fresh-enough token, fetching a new one if needed
async function ensureFreshToken(action = 'rego_check') {
  const age = Date.now() - recaptchaFetchedAt;
  const needsRefresh = !recaptchaToken || age > REFRESH_THRESHOLD_MS;

  if (!needsRefresh) return recaptchaToken;

  // coalesce simultaneous calls
  if (!inFlightTokenPromise) {
    inFlightTokenPromise = getRecaptchaToken(action)
      .catch(err => { throw err; })
      .finally(() => { inFlightTokenPromise = null; });
  }
  return inFlightTokenPromise;
}

// --- boot: get a token on page load ---
// document.addEventListener('DOMContentLoaded', async () => {
//   try {
//     await ensureFreshToken('page_load');
//     // console.log('Initial token fetched');
//   } catch (e) {
//     console.error('Initial reCAPTCHA token fetch failed:', e);
//   }
// });

document.addEventListener('DOMContentLoaded', () => {
  const forms = [
    document.getElementById('regoCheckFormWheel'),
    document.getElementById('regoCheckForm')
  ];

  let recaptchaLoaded = false;

  // When the user first touches any form
  async function onFirstTouch() {
    if (recaptchaLoaded) return; // Prevent multiple calls
    recaptchaLoaded = true;

    try {
      await ensureFreshToken('page_load');
      // console.log('reCAPTCHA token fetched after first user interaction');
    } catch (e) {
      console.error('reCAPTCHA token fetch failed:', e);
    }

    // Remove all event listeners after first touch
    removeRegoListeners();
  }

  const events = ['click', 'focusin', 'touchstart'];

  function addRegoListeners() {
    forms.forEach(form => {
      if (form) events.forEach(evt => form.addEventListener(evt, onFirstTouch, { once: true }));
    });
  }

  function removeRegoListeners() {
    forms.forEach(form => {
      if (form) events.forEach(evt => form.removeEventListener(evt, onFirstTouch));
    });
  }

  // Start listening
  addRegoListeners();
});

// JS for the Tyre & Wheels tabs 
const outterTab = document.querySelectorAll('.outterTab')
const outtercontent = document.querySelectorAll('.outtercontent')

outterTab.forEach(tab => {
  tab.addEventListener("click", () => {
    // Remove active state from all tabs and contents
    outterTab.forEach(t => t.classList.remove('active'));
    outtercontent.forEach(content => content.classList.remove('active'));

    // Add active state to the clicked tab
    tab.classList.add('active');

    // Add active state to the corresponding content
    const target = tab.getAttribute('data-tab');
    document.getElementById(`content-${target}`).classList.add('active');
  })
})

// JS for the tyre tab section
const tyreTab = document.querySelectorAll('.tyre-tab');
const tyreContent = document.querySelectorAll('.tyre-content');

tyreTab.forEach(tab => {
  tab.addEventListener('click', () => {
    // Remove active state from all tabs and contents
    tyreTab.forEach(t => t.classList.remove('active'));
    tyreContent.forEach(content => content.classList.remove('active'));

    // Add active state to the clicked tab
    tab.classList.add('active');

    // Add active class to the corresponding content
    const target = tab.getAttribute('data-tab');
    document.getElementById(`tyre-content-${target}`).classList.add('active');
  });
});

// JS for the wheel tabs section
const wheelTabs = document.querySelectorAll('.wheel-tab');
const contents = document.querySelectorAll('.content-wheel');

wheelTabs.forEach(tab => {
  tab.addEventListener('click', () => {
    // Remove active state from all tabs and contents
    wheelTabs.forEach(t => t.classList.remove('active'));
    contents.forEach(content => content.classList.remove('active'));

    // Add active state to the clicked tab
    tab.classList.add('active');

    // Add active class to the corresponding content
    const target = tab.getAttribute('data-tab');
    document.getElementById(`content-wheel-${target}`).classList.add('active');
  });
});

// Always safe to clear loading on page show
window.addEventListener('pageshow', (e) => {
  const findTyreTextVehicle = document.getElementById('findTyreVehicle');
  const tyreVehicleButton = document.getElementById("tyreVehicleButton")
  const loaderIconVehicle = document.getElementById('loaderVehicle');

  function stopLoading() {
    tyreVehicleButton.disabled = false;
    loaderIconVehicle.style.display = 'none';
    findTyreTextVehicle.style.display = 'block';
  }
  
  stopLoading();
});

document.addEventListener('DOMContentLoaded', () => {

  // ------------------------- local arrays --------------------------
  const speedIndexesArray = [
    "J", "K", "L", "M", "N", "P", "Q", "R", "S", "T", "U",
    "H", "V", "W", "Y", "VR", "ZR"
  ];

  const loadIndexesArray = [
  "72",
  "77",
  "79",
  "80",
  "81",
  "82",
  "83",
  "84",
  "85",
  "86",
  "87",
  "88",
  "88/86",
  "89",
  "90",
  "90/88",
  "91",
  "92",
  "93",
  "94",
  "95",
  "96",
  "97",
  "97/95",
  "98",
  "99",
  "99/98",
  "100",
  "100/97",
  "101",
  "102",
  "102/99",
  "102/100",
  "103",
  "103/100",
  "103/101",
  "104",
  "104/100",
  "104/101",
  "104/102",
  "105",
  "106",
  "106/103",
  "106/104",
  "107",
  "107/103",
  "107/105",
  "108",
  "108/104",
  "108/106",
  "109",
  "109/105",
  "109/107",
  "110",
  "110/107",
  "110/108",
  "111",
  "111/108",
  "111/109",
  "112",
  "112/110",
  "113",
  "113/110",
  "113/111",
  "114",
  "114/110",
  "114/112",
  "115",
  "115/112",
  "116",
  "116/112",
  "116/113",
  "116/114",
  "117",
  "117/114",
  "117/115",
  "118",
  "118/115",
  "118/116",
  "119",
  "119/116",
  "120",
  "120/116",
  "120/117",
  "120/118",
  "121",
  "121/118",
  "121/119",
  "121/120",
  "122",
  "122/119",
  "123",
  "123/120",
  "124",
  "124/121",
  "124/123",
  "125",
  "125/122",
  "126",
  "126/123",
  "127",
  "127/124",
  "128",
  "128/125",
  "128/126",
  "129",
  "129/126"
]


  // ------------------------- Configuration -------------------------
  const BASE_URL = 'https://vehicle-logic-vqxgw.ondigitalocean.app/'
  const MAKES_API_URL = `${BASE_URL}api/makes`;
  const SECTION_WIDTHS_API_URL = `${BASE_URL}api/tyres/sizes/sectionWidths`

  // ------------------------- Element References -------------------------
  // wheel rego
  const regoCheckFormWheel = document.getElementById('regoCheckFormWheel'); 
  const wheelStateInput = document.getElementById('state-wheel');
  const wheelRegoInput = document.getElementById('rego-wheel');
  const wheelRegoError = document.getElementById('rego-error-wheel');
  const wheelLoaderIcon = document.getElementById('loader-wheel');
  const wheelRegoButton = document.getElementById('wheelRegoButton')
  const findWheelText = document.getElementById('find-wheel');
  
  // tyre rego
  const regoCheckForm = document.getElementById('regoCheckForm');
  const stateInput = document.getElementById('state');
  const regoInput = document.getElementById('rego');
  const regoError = document.getElementById('rego-error');
  const loaderIcon = document.getElementById('loader');
  const tyreRegoButton = document.getElementById('tyreRegoButton');
  const findTyreText = document.getElementById('findTyre');

  // wheel vehicle size
  const wheelVehicle = document.getElementById('wheel-vehicle');
  const vehicleWheelDetailForm = document.getElementById('vehicleWheelDetailForm');
  const wheelMakeSelect = document.getElementById('wheel-make');
  const wheelYearSelect = document.getElementById('wheel-year');
  const wheelModelSelect = document.getElementById('wheel-model');
  const wheelSeriesSelect = document.getElementById('wheel-series');
  const findWheelTextVehicle = document.getElementById('findWheelVehicle');
  const wheelVehicleButton = document.getElementById('wheelVehicleButton')
  const wheelLoaderIconVehicle = document.getElementById('loaderWheelVehicle');
  
  // tyre vehicle size
  const tyreVehicle = document.getElementById('tyre-vehicle');
  const vehicleDetailForm = document.getElementById('vehicleDetailForm');
  const makeSelect = document.getElementById('make');
  const yearSelect = document.getElementById('year');
  const modelSelect = document.getElementById('model');
  const seriesSelect = document.getElementById('series');
  const findTyreTextVehicle = document.getElementById('findTyreVehicle');
  const tyreVehicleButton = document.getElementById("tyreVehicleButton")
  const loaderIconVehicle = document.getElementById('loaderVehicle');

  // tyre size
  const tyreSize = document.getElementById("tyre-size")
  const tyreSizeForm = document.getElementById('tyreSizeForm');
  const sectionWidthSelect = document.getElementById('section-width');
  const aspectRatioSelect = document.getElementById('aspect-ratio');
  const rimDiameterSelect = document.getElementById('rim-diameter');
  const responseContent = document.getElementById('responseContent') || { textContent: '' };
  const findTyreTextSize = document.getElementById('findTyreSize');
  const loaderIconSize = document.getElementById('loaderSize');
  const tyreSizeButton = document.getElementById('tyreSizeButton');

  const VehicleCategorylist = [
    "PASSENGER",
    "SOFTROADER",
    "STEEL",
    "LIGHT TRUCKS"
  ];


  // ------------------------- Helper Functions -------------------------


  // Generic GET request with Bearer token
  async function fetchWithToken(url) {
    const response = await fetch(url, {
      method: 'GET',
      headers: { 'x-api-key': '1160aaf5feaa534399a169da613a5ace81600ef9d96ad7b173699cdb59a9b17d' }
    });
    if (!response.ok) {
      throw new Error(`Failed to fetch data from ${url}: ${response.statusText}`);
    }
    return response.json();
  }

  // Populate a select dropdown with given items
  function populateDropdown(selectElement, items, title, valueKey = 'Id', textKey = 'Name', clearBefore = true) {
    if (clearBefore) {
      selectElement.innerHTML = '';
      selectElement.innerHTML = `<option value="" disabled selected hidden>Select ${title}</option>`;
    }
  
    items.forEach(item => {
      const option = document.createElement('option');
      option.value = item[valueKey];
      option.textContent = item[textKey];
      selectElement.appendChild(option);
    });
  }

  function removeElements(selectElement, title) {
    selectElement.innerHTML = '';
    selectElement.innerHTML = `<option value="" disabled selected hidden>Select ${title}</option>`;
  }

  // Construct search query and redirect to Shopify search
  function redirectToSearch(vehicleName, vehicleId, tyreDescription,tyreDescriptionRear, runFlat, mixedTyreSize, vehicleYear, tyreSizesString, sectionWidthsString, aspectRatiosString, rimDiametersString, loadIndexesString, speedIndexes, tyreIdsString) {
    
    const trimmedName = vehicleName.split(" ").slice(0, 4).join(' ');
    let searchQuery;
    /*
    if (mixedTyreSize){
      searchQuery = `variants.sku:${tyreIdsString} Tyres`;
    } else {
      searchQuery =`variants.sku:${tyreIdsString} Tyres`;
    }
    */
    const skuQuery = tyreIdsString.split(' OR ').map(sku => `variants.sku:${sku.trim()}`).join(' OR ');
    searchQuery = `(${skuQuery}) Tyres`;

    // &filter.p.m.custom.speed_index=${speedIndexes}
    // &filter.p.m.custom.load_index=${loadIndexesString}
    // &filter.p.m.custom.load_index=${loadIndexesString}

    const targetUrl = mixedTyreSize
      ? `/search?q=${searchQuery}&filter.p.m.custom.aspect_ratio=${aspectRatiosString}&filter.p.m.custom.rim_diameter=${rimDiametersString}&filter.p.m.custom.section_width=${sectionWidthsString}&filter.p.m.custom.run_flat=${runFlat}&vehicleName=${trimmedName}&mixedTyreSize=${mixedTyreSize}&vehicleYear=${vehicleYear}&vehicleId=${vehicleId}&standardFrontTyreSize=${tyreDescription}&standardRearTyreSize=${tyreDescriptionRear}`
      : `/search?q=${searchQuery}&filter.p.m.custom.aspect_ratio=${aspectRatiosString}&filter.p.m.custom.rim_diameter=${rimDiametersString}&filter.p.m.custom.section_width=${sectionWidthsString}&filter.p.m.custom.run_flat=${runFlat}&vehicleName=${trimmedName}&mixedTyreSize=${mixedTyreSize}&vehicleYear=${vehicleYear}&vehicleId=${vehicleId}&standardTyreSize=${tyreDescription}`;

    // Persist the full factory search URL so we can restore it when the user
    // switches back to Factory fitment on the search page (see facets.js).
    if (vehicleId) {
      try {
        localStorage.setItem('factory_tyre_url_' + vehicleId, targetUrl);
      } catch (e) {
        // Storage quota likely exceeded — clear old factory_tyre_* entries and retry once.
        try {
          Object.keys(localStorage)
            .filter((k) => k.startsWith('factory_tyre_url_') || k.startsWith('factory_tyre_query_'))
            .forEach((k) => localStorage.removeItem(k));
          localStorage.setItem('factory_tyre_url_' + vehicleId, targetUrl);
        } catch (_) {
          // Give up silently; facets.js will gracefully fall back to size-based query.
        }
      }
    }

    window.location.href = targetUrl;
  }

  function redirectToWheelSearch(vehicleName, vehicleId, vehicleYear, fitmentType, wheelIdsString, pcdsString, offsetsString, studsString, hubDiametersString, rimDiametersString, rimWidthsString, frontWheelRimDiameter, rearWheelRimDiameter, frontWheelRimWidth, rearWheelRimWidth, standardPcd, StandardWheelStud){
    const trimmedName = vehicleName.split(" ").slice(0, 4).join(' ');
    //const searchQuery = `variants.sku:${wheelIdsString} Wheels`;
    const skuQuery = wheelIdsString.split(' OR ').map(sku => `variants.sku:${sku.trim()}`).join(' OR ');
    const searchQuery = `(${skuQuery}) Wheels`;

    // &filter.p.m.custom.rim_diameter=${rimDiametersString}&filter.p.m.custom.rim_width=${rimWidthsString}&filter.p.m.custom.hub_diameter=${hubDiametersString}&filter.p.m.custom.offset=${offsetsString}
    window.location.href = `/search?q=${searchQuery}&frontRimDiameter=${frontWheelRimDiameter}&rearRimDiameter=${rearWheelRimDiameter}&vehicleName=${trimmedName}&vehicleId=${vehicleId}&vehicleYear=${vehicleYear}&frontWidths=${frontWheelRimWidth}&rearWidths=${rearWheelRimWidth}&fitmentType=${fitmentType}&filter.p.m.custom.pcd=${standardPcd}&filter.p.m.custom.studs=${StandardWheelStud}`; 
  }

  // capitalize the word
  function capitalize(word) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }

  function getSpeedIndexesFrom(frontIndex, rearIndex) {
    // Convert input to uppercase to handle case-insensitive matching
    const upperFrontIndex = frontIndex.toUpperCase();
    const upperRearIndex = rearIndex.toUpperCase();
    
    // Find the index of the given speed index in the array
    const startFrontIndex = speedIndexesArray.indexOf(upperFrontIndex);
    const startRearIndex = speedIndexesArray.indexOf(upperRearIndex);
    
    // If the speed index is not found, return an empty array or handle as needed
    if (startFrontIndex === -1 || startRearIndex === -1) {
        return [];
    }
    
    // Return all elements from the found index to the end of the array
    if (upperFrontIndex === upperRearIndex) {
      return speedIndexesArray.slice(startFrontIndex);
    } else if (upperFrontIndex > upperRearIndex) {
      return speedIndexesArray.slice(upperRearIndex);
    } else if (upperRearIndex > upperFrontIndex) {
      return speedIndexesArray.slice(upperFrontIndex);
    }
  }

  function getLoadIndexesFrom(frontLoad, rearLoad) {
    // Find the index of the given load index in the array
    const startFrontIndex = loadIndexesArray.indexOf(frontLoad);
    const startRearIndex = loadIndexesArray.indexOf(rearLoad);

    // if the load index is not found, return empty array or handle as needed
    if (startFrontIndex === -1 || startRearIndex === -1) {
      return [];
    }

    // Return all elements from the found index to the end of the array
    if (startFrontIndex === startRearIndex) {
      return loadIndexesArray.slice(startFrontIndex);
    } else if (startFrontIndex > startRearIndex) {
      return loadIndexesArray.slice(startRearIndex);
    } else if (startRearIndex > startFrontIndex) {
      return loadIndexesArray.slice(startFrontIndex);
    }
  }

// ------------------------- Event Handlers -------------------------
  // Handle Registration Check Wheel Form Submission
  if (wheelStateInput && wheelRegoInput && wheelRegoButton) {
    function checkTyreInputs() {
      if (wheelStateInput.value.trim() !== '' && wheelRegoInput.value.trim() !== '') {
        wheelRegoButton.disabled = false;
      } else {
        wheelRegoButton.disabled = true;
      }
    }
    
    wheelStateInput.addEventListener('change', checkTyreInputs);
    wheelRegoInput.addEventListener('input', checkTyreInputs);
  }
  if (regoCheckFormWheel) {
    regoCheckFormWheel.addEventListener('submit', async (event) => {
      event.preventDefault();
      wheelLoaderIcon.style.display = 'block'
      findWheelText.style.display = 'none'
      const state = wheelStateInput.value;
      const lpn = wheelRegoInput.value.trim();
      // Check if Rego is empty or exceeds 8 characters
      if (!lpn) {
        event.preventDefault();
        wheelRegoError.textContent = 'Rego cannot be empty. Please enter a valid Rego Number.';
      }

      const regoCacheKey = `rego_${state}_${lpn.toUpperCase()}`;
      const wheelCacheKey = `wheels_${state}_${lpn.toUpperCase()}`;
      let regoData;
      let wheelDataResult;

      try {
        // Load Rego data from cache or API
        const cachedData = getFromLocalStorageWithExpiry(regoCacheKey);
        const WheelData = getFromLocalStorageWithExpiry(wheelCacheKey);
        //console.log(cachedData);
        //console.log(WheelData);

        if (cachedData && WheelData) {
          //regoData = JSON.parse(cachedData);
          regoData = cachedData;
          wheelDataResult = WheelData;
          //console.log('Using cached data for:', lpn, state);
        }
        else{
          const token = await ensureFreshToken('rego_submit');

          const url = `${BASE_URL}api/licenceplate/vehicle/details/wheels` +
                  `?lpn=${encodeURIComponent(lpn)}` +
                  `&state=${encodeURIComponent(state)}` +
                  `&token=${encodeURIComponent(token)}`;
          const data = await fetchWithToken(url);
          regoData = data?.regoData;
          wheelDataResult = data?.wheelDataResult;

          // Save to cache
          const now = new Date();
          const expiryInDays = 14;
          const regoDataWithExpiry = {
            data: regoData,
            expiry: now.getTime() + expiryInDays * 24 * 60 * 60 * 1000
          };
          localStorage.setItem(regoCacheKey, JSON.stringify(regoDataWithExpiry));

          const wheelDataWithExpiry = {
            data: wheelDataResult,
            expiry: now.getTime() + expiryInDays * 24 * 60 * 60 * 1000
          };
          localStorage.setItem(wheelCacheKey, JSON.stringify(wheelDataWithExpiry));
          //console.log('Fetched and cached data for:', lpn, state);
        }

        // wheel datailed data 
        const vehicleName = regoData.Name;
        const vehicleId = regoData?.Id;
        const vehicleYear = regoData?.Year;
        const fitmentType = regoData?.OEFitmentData?.FitmentType;
        const StandardWheelStud = regoData?.OEFitmentData?.WheelStud;
        const standardPcd = regoData?.OEFitmentData?.PCD;

         // front wheel detail
        const frontWheelRimDiameter = regoData?.OEFitmentData?.FrontWheels?.RimDiameter;
        const frontWheelRimWidth = regoData?.OEFitmentData?.FrontWheels?.RimWidth;
        
        // rear wheel dateil
        const rearWheelRimDiameter = regoData?.OEFitmentData?.RearWheels?.RimDiameter;
        const rearWheelRimWidth = regoData?.OEFitmentData?.RearWheels?.RimWidth;

        let wheelIds = [];
        let pcds = [];
        let offsets = [];
        let studs = [];
        let hubDiameters = [];
        let rimDiameters = [];
        let rimWidths = [];

        wheelDataResult.Items.forEach(item => {
          item.WheelFitments.forEach(fitment => {
            wheelIds.push(fitment.FrontWheel.Id + "W");
            wheelIds.push(fitment.RearWheel.Id + "W");

            pcds.push(fitment.FrontWheel.PCD);
            pcds.push(fitment.RearWheel.PCD);

            offsets.push(fitment.FrontWheel.Offset);
            offsets.push(fitment.RearWheel.Offset);

            studs.push(fitment.FrontWheel.Studs);
            studs.push(fitment.RearWheel.Studs);

            hubDiameters.push(fitment.FrontWheel.HubDiameter);
            hubDiameters.push(fitment.RearWheel.HubDiameter);

            rimDiameters.push(fitment.FrontWheel.Size.RimDiameter);
            rimDiameters.push(fitment.RearWheel.Size.RimDiameter);

            rimWidths.push(fitment.FrontWheel.Size.RimWidth);
            rimWidths.push(fitment.RearWheel.Size.RimWidth);
          });
        });
        
        const uniqueWheelIds = [...new Set(wheelIds)];
        const uniquePcds = [...new Set(pcds)];
        const uniqueOffsets = [...new Set(offsets)];
        const uniqueStuds = [...new Set(studs)];
        const uniqueHubDiameters = [...new Set(hubDiameters)];
        const uniqueRimDiameters = [...new Set(rimDiameters)];
        const uniqueRimWidths = [...new Set(rimWidths)];

        const wheelIdsString = uniqueWheelIds.join(' OR ');
        const pcdsString = uniquePcds.join(',');
        const offsetsString = uniqueOffsets.join(',');
        const studsString = uniqueStuds.join(',');
        const hubDiametersString = uniqueHubDiameters.join(',');
        const rimDiametersString = uniqueRimDiameters.join(',');
        const rimWidthsString = uniqueRimWidths.join(',');
          
        redirectToWheelSearch(vehicleName, vehicleId, vehicleYear, fitmentType, wheelIdsString, pcdsString, offsetsString, studsString, hubDiametersString, rimDiametersString, rimWidthsString, frontWheelRimDiameter, rearWheelRimDiameter, frontWheelRimWidth, rearWheelRimWidth, standardPcd, StandardWheelStud)
      
      } catch (error) {
        responseContent.textContent = 'Error: ' + error.message;
        console.error('There was a problem with the rego fetch operation:', error);
        wheelRegoError.textContent = 'Please enter a valid Rego Number.';
        wheelRegoInput.classList.add('error');
        wheelLoaderIcon.style.display = 'none'
        findWheelText.style.display = 'block'
      }
    });
  }
  
  // Handle Registration Check Tyre Form Submission
  if (stateInput && regoInput && tyreRegoButton) {
    function checkTyreInputs() {
      if (stateInput.value.trim() !== '' && regoInput.value.trim() !== '') {
        tyreRegoButton.disabled = false;
      } else {
        tyreRegoButton.disabled = true;
      }
    }
    
    stateInput.addEventListener('change', checkTyreInputs);
    regoInput.addEventListener('input', checkTyreInputs);
  }
  if (regoCheckForm) {
    regoCheckForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      loaderIcon.style.display = 'block'
      findTyreText.style.display = 'none'
      const state = stateInput.value;
      const lpn = regoInput.value.trim();
      const ip = "5.112.87.32";
      const regocheck = true;
      // Check if Rego is empty or exceeds 8 characters (HTML maxlength also helps)
      if (!lpn) {
        event.preventDefault();
        regoError.textContent = 'Rego cannot be empty. Please enter a valid Rego Number.';
      }

      const regoCacheKey = `rego_${state}_${lpn.toUpperCase()}`;
      const tyresCacheKey = `tyres_${state}_${lpn.toUpperCase()}`;
      let regoData;
      let tyrePatternsResult;

      try {
        // Load Rego data from cache or API
        const cachedData = getFromLocalStorageWithExpiry(regoCacheKey);
        const tyresData = getFromLocalStorageWithExpiry(tyresCacheKey);
        //console.log(cachedData);

        if (cachedData && tyresData) {
          //regoData = JSON.parse(cachedData);
          regoData = cachedData;
          tyrePatternsResult = tyresData;
          //console.log('Using cached data for:', lpn, state);
        }
        else{
          
          const token = await ensureFreshToken('rego_submit');

          const url = `${BASE_URL}api/licenceplate/vehicle/details/patterns` +
                  `?lpn=${encodeURIComponent(lpn)}` +
                  `&state=${encodeURIComponent(state)}` +
                  `&token=${encodeURIComponent(token)}`;
          const data = await fetchWithToken(url);
          regoData = data?.regoData;
          tyrePatternsResult = data?.tyrePatternsResult;

          // Save to cache
          const now = new Date();
          const expiryInDays = 14;
          const regoDataWithExpiry = {
            data: regoData,
            expiry: now.getTime() + expiryInDays * 24 * 60 * 60 * 1000
          };
          localStorage.setItem(regoCacheKey, JSON.stringify(regoDataWithExpiry));

          const tyresDataWithExpiry = {
            data: tyrePatternsResult,
            expiry: now.getTime() + expiryInDays * 24 * 60 * 60 * 1000
          };
          localStorage.setItem(tyresCacheKey, JSON.stringify(tyresDataWithExpiry));

          //console.log('Fetched and cached data for:', lpn, state);
        }
        
        let tyreSizes = [];
        let sectionWidths = [];
        let aspectRatios = [];
        let rimDiameters = [];
        const vehicleName = regoData.Name || '';
        const vehicleYear = regoData.Year || '';
        const vehicleId = regoData?.Id || '';
        const tyreDescription = regoData?.OEFitmentData?.FrontTyres?.Description || '';
        const tyreDescriptionRear = regoData?.OEFitmentData?.RearTyres?.Description || '';
        const frontLoadIndex = regoData?.OEFitmentData?.FrontTyres?.LoadIndex || '';
        const rearLoadIndex = regoData?.OEFitmentData?.RearTyres?.LoadIndex || '';
        const frontSpeedIndex = regoData?.OEFitmentData?.FrontTyres?.SpeedIndex || '';
        const rearSpeedIndex = regoData?.OEFitmentData?.RearTyres?.SpeedIndex || '';
        const runFlat = regoData?.OEFitmentData?.RunFlat === true ? 1 : 0;
        const mixedTyreSize = regoData?.OEFitmentData?.FrontTyres?.Description !== regoData?.OEFitmentData?.RearTyres?.Description;

        const loadIndexes = getLoadIndexesFrom(frontLoadIndex, rearLoadIndex)
        const loadIndexesString = loadIndexes.join(",")

        const speedIndexes = getSpeedIndexesFrom(frontSpeedIndex, rearSpeedIndex);
        const speedIndexesString = speedIndexes.join(",")
        
        rimDiameters.push(regoData?.OEFitmentData?.FrontTyres?.RimDiameter);
        rimDiameters.push(regoData?.OEFitmentData?.RearTyres?.RimDiameter);

        sectionWidths.push(regoData?.OEFitmentData?.FrontTyres?.SectionWidth);
        sectionWidths.push(regoData?.OEFitmentData?.RearTyres?.SectionWidth);

        aspectRatios.push(regoData?.OEFitmentData?.FrontTyres?.AspectRatio);
        aspectRatios.push(regoData?.OEFitmentData?.RearTyres?.AspectRatio);

        let tyreIds = [];
        
        tyrePatternsResult.Items.forEach(item => {
          item.TyreFitments.forEach(fitment => {
            if (fitment?.FrontTyre?.Id) tyreIds.push(fitment?.FrontTyre?.Id)
            if (fitment?.RearTyre?.Id) tyreIds.push(fitment?.RearTyre?.Id)

            if (fitment?.FrontTyre?.Size?.Description) sectionWidths.push(fitment?.FrontTyre?.Size?.SectionWidth)
            if (fitment?.RearTyre?.Size?.SectionWidth) sectionWidths.push(fitment.RearTyre?.Size?.SectionWidth)

            if (fitment.FrontTyre?.Size?.AspectRatio) aspectRatios.push(fitment?.FrontTyre?.Size?.AspectRatio)
            if (fitment.RearTyre?.Size?.AspectRatio) aspectRatios.push(fitment?.RearTyre?.Size?.AspectRatio)

            if (fitment.FrontTyre?.Size?.RimDiameter) rimDiameters.push(fitment?.FrontTyre?.Size?.RimDiameter)
            if (fitment.RearTyre?.Size?.RimDiameter) rimDiameters.push(fitment.RearTyre?.Size?.RimDiameter)

            if (fitment.FrontTyre?.Description) tyreSizes.push(fitment.FrontTyre?.Description);
            if (fitment.RearTyre?.Description) tyreSizes.push(fitment.RearTyre?.Description);
          });
        });
        
        const uniqueTyreIds = [...new Set(tyreIds)];
        const uniqueTyreSizes = [...new Set(tyreSizes)];
        const uniqueSectionWidths = [...new Set(sectionWidths)];
        const uniqueAspectRatios = [...new Set(aspectRatios)];
        const uniqueRimDiameters = [...new Set(rimDiameters)];

        const tyreIdsString = uniqueTyreIds.join(" OR ");
        const tyreSizesString = uniqueTyreSizes.join(' OR ');
        const sectionWidthsString = uniqueSectionWidths.join(',');
        const aspectRatiosString = uniqueAspectRatios.join(',');
        const rimDiametersString = uniqueRimDiameters.join(',');
        
        redirectToSearch(vehicleName, vehicleId, tyreDescription,tyreDescriptionRear, runFlat, mixedTyreSize, vehicleYear, tyreSizesString, sectionWidthsString, aspectRatiosString, rimDiametersString, loadIndexesString, speedIndexes, tyreIdsString);
      
      } catch (error) {
        responseContent.textContent = 'Error: ' + error.message;
        console.error('There was a problem with the rego fetch operation:', error);
        regoError.textContent = 'Please enter a valid Rego Number.';
        regoInput.classList.add('error');
        loaderIcon.style.display = 'none'
        findTyreText.style.display = 'block'
      }
    });
  }
  
  //fetch wheel makes
  wheelVehicle.addEventListener('click', async (event) => { 
    event.preventDefault();
    try {
      const data = await fetchWithToken(MAKES_API_URL);
      populateDropdown(wheelMakeSelect, data.Items, "Make");
      wheelMakeSelect.removeAttribute('disabled');
    } catch (error) {
      responseContent.textContent = 'Error: ' + error.message;
      console.error('Error fetching makes:', error);
    }
  });
  
    // Handle Wheel Make selection -> Load Wheel Year
  wheelMakeSelect.addEventListener('change', async (event) => {
    event.preventDefault();
    const selectedWheelMake = wheelMakeSelect.value;
    if (!selectedWheelMake) return;
    try {
      const url = `${BASE_URL}api/make/${selectedWheelMake}`;
      const data = await fetchWithToken(url);
      const startYear = data.YearRanges[0].Start;
      const endYear = data.YearRanges[0].End;
      
      // remove elements in the selects
      removeElements(wheelYearSelect, "Year")
      removeElements(wheelModelSelect, "Model")
      removeElements(wheelSeriesSelect, "Series")
      
      // Populate year dropdown
      for (let y = startYear; y <= endYear; y++) {
        const option = document.createElement('option');
        option.value = y;
        option.textContent = y;
        wheelYearSelect.appendChild(option);
      }
      wheelYearSelect.removeAttribute('disabled');
    } catch (error) {
      responseContent.textContent = 'Error: ' + error.message;
      console.error('Error fetching year range:', error);
    }
  });
  
  // Handle Year selection -> Load Models
  wheelYearSelect.addEventListener('change', async (event) => {
    event.preventDefault();
    const selectedWheelYear = wheelYearSelect.value;
    const selectedWheelMake = wheelMakeSelect.value;
    if (!selectedWheelYear || !selectedWheelMake) return;
    try {
      const url = `${BASE_URL}api/models?VehicleMakeIds=${selectedWheelMake}&Year=${selectedWheelYear}`;
      const data = await fetchWithToken(url);
      
      // remove elements in the selects
      removeElements(wheelModelSelect, "Model")
      removeElements(wheelSeriesSelect, "Series")
      
      populateDropdown(wheelModelSelect, data.Items, "Model");
      wheelModelSelect.removeAttribute('disabled');
    } catch (error) {
      responseContent.textContent = 'Error: ' + error.message;
      console.error('Error fetching models:', error);
    }
  });
  
  // Handle Model selection -> Load Series
  wheelModelSelect.addEventListener('change', async (event) => {
    event.preventDefault();
    const selectedWheelYear = wheelYearSelect.value;
    const selectedWheelModel = wheelModelSelect.value;
    if (!selectedWheelYear || !selectedWheelModel) return;
    try {
      const url = `${BASE_URL}api/series?ModelId=${selectedWheelModel}&Year=${selectedWheelYear}`;
      const data = await fetchWithToken(url);
      
      // remove elements in the selects
      removeElements(wheelSeriesSelect, "Series")
      
      // If you need custom text formatting for the Name, do it here
      populateDropdown(wheelSeriesSelect, data.Items, "Series", 'Id', 'Name', true);
      wheelSeriesSelect.removeAttribute('disabled');
    } catch (error) {
      responseContent.textContent = 'Error: ' + error.message;
      console.error('Error fetching series:', error);
    }
  });

  wheelSeriesSelect.addEventListener("change", () => {
    event.preventDefault()
    wheelVehicleButton.disabled = false;
  })
  
  // Handle Vehicle Wheel Detail Form Submission
  if (vehicleWheelDetailForm) {
    vehicleWheelDetailForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      wheelLoaderIconVehicle.style.display = 'block'
      findWheelTextVehicle.style.display = 'none'
      const wheelVehicleId = wheelSeriesSelect.value;
      const wheelVehicleName = wheelSeriesSelect.selectedOptions[0].textContent;
      if (!wheelVehicleId) {
        alert('Please select a series.');
        return;
      }
      try {
        const url = `${BASE_URL}api/vehicles/details/${wheelVehicleId}/wheels`;
        const data = await fetchWithToken(url);
        const vehicleResult = data?.vehicleResult;
        const wheelsResult = data?.wheelsResult;

        // wheel datailed data 
        const vehicleName = vehicleResult.Name;
        const vehicleId = vehicleResult?.Id;
        console.log('vehicleId', vehicleId)
        const vehicleYear = vehicleResult?.Year;
        const fitmentType = vehicleResult?.OEFitmentData?.FitmentType;
        const StandardWheelStud = vehicleResult?.OEFitmentData?.WheelStud;
        const standardPcd = vehicleResult?.OEFitmentData?.PCD;
        const frontStandardRimDiamter = vehicleResult?.OEFitmentData?.FrontWheels?.RimDiameter;
        const rearStandardRimDiameter = vehicleResult?.OEFitmentData?.RearWheels?.RimDiameter;
        const frontStandardRimWidth = vehicleResult?.OEFitmentData?.FrontWheels?.RimWidth;
        const rearStandardRimWidth = vehicleResult?.OEFitmentData?.RearWheels?.RimWidth;
        let vehicleCategory;

        if (VehicleCategorylist.includes(vehicleResult?.Class)) {
          vehicleCategory = capitalize(vehicleResult?.Class)
        } else {
          vehicleCategory = vehicleResult?.Class
        }

        let wheelIds = [];
        let pcds = [];
        let offsets = [];
        let studs = [];
        let hubDiameters = [];
        let rimDiameters = [];
        let rimWidths = [];

        wheelsResult.Items.forEach(item => {
          item.WheelFitments.forEach(fitment => {
            wheelIds.push(fitment.FrontWheel.Id + "W");
            wheelIds.push(fitment.RearWheel.Id + "W");

            pcds.push(fitment.FrontWheel.PCD);
            pcds.push(fitment.RearWheel.PCD);

            offsets.push(fitment.FrontWheel.Offset);
            offsets.push(fitment.RearWheel.Offset);

            studs.push(fitment.FrontWheel.Studs);
            studs.push(fitment.RearWheel.Studs);

            hubDiameters.push(fitment.FrontWheel.HubDiameter);
            hubDiameters.push(fitment.RearWheel.HubDiameter);

            rimDiameters.push(fitment.FrontWheel.Size.RimDiameter);
            rimDiameters.push(fitment.RearWheel.Size.RimDiameter);

            rimWidths.push(fitment.FrontWheel.Size.RimWidth);
            rimWidths.push(fitment.RearWheel.Size.RimWidth);
          });
        });
        
        const uniqueWheelIds = [...new Set(wheelIds)];
        const uniquePcds = [...new Set(pcds)];
        const uniqueOffsets = [...new Set(offsets)];
        const uniqueStuds = [...new Set(studs)];
        const uniqueHubDiameters = [...new Set(hubDiameters)];
        const uniqueRimDiameters = [...new Set(rimDiameters)];
        const uniqueRimWidths = [...new Set(rimWidths)];

        const wheelIdsString = uniqueWheelIds.join(' OR ');
        const pcdsString = uniquePcds.join(',');
        const offsetsString = uniqueOffsets.join(',');
        const studsString = uniqueStuds.join(',');
        const hubDiametersString = uniqueHubDiameters.join(',');
        const rimDiametersString = uniqueRimDiameters.join(',');
        const rimWidthsString = uniqueRimWidths.join(',');
        
        // front wheel detail
        const frontWheelRimDiameter = vehicleResult?.OEFitmentData?.FrontWheels?.RimDiameter;
        const frontWheelRimWidth = vehicleResult?.OEFitmentData?.FrontWheels?.RimWidth;
        
        // rear wheel dateil
        const rearWheelRimDiameter = vehicleResult?.OEFitmentData?.RearWheels?.RimDiameter;
        const rearWheelRimWidth = vehicleResult?.OEFitmentData?.RearWheels?.RimWidth;
        
        redirectToWheelSearch(vehicleName, vehicleId, vehicleYear, fitmentType, wheelIdsString, pcdsString, offsetsString, studsString, hubDiametersString, rimDiametersString, rimWidthsString, frontWheelRimDiameter, rearWheelRimDiameter, frontWheelRimWidth, rearWheelRimWidth, standardPcd, StandardWheelStud)
      
      } catch (error) {
        responseContent.textContent = 'Error: ' + error.message;
        console.error('Error fetching vehicle details:', error);
        wheelLoaderIconVehicle.style.display = 'none'
        findWheelTextVehicle.style.display = 'block'
      }
    });
  }

//fetch tyre makes
    tyreVehicle.addEventListener('click', async(event) => {
      event.preventDefault();
      try {
        const data = await fetchWithToken(MAKES_API_URL);
        populateDropdown(makeSelect, data.Items, "Make");
        makeSelect.removeAttribute('disabled');
      } catch (error) {
        responseContent.textContent = 'Error: ' + error.message;
        console.error('Error fetching makes:', error);
      }
    })
  

    // Handle Make selection -> Load Year
  makeSelect.addEventListener('change', async (event) => {
    event.preventDefault();

    const selectedMake = makeSelect.value;
    if (!selectedMake) return;

    try {
      const url = `${BASE_URL}api/make/${selectedMake}`;
      const data = await fetchWithToken(url);

      // We assume YearRanges[0] exists as per your original code
      const startYear = data.YearRanges[0].Start;
      const endYear = data.YearRanges[0].End;
      
      // remove elements in the selects
      removeElements(yearSelect, "Year")
      removeElements(modelSelect, "Model")
      removeElements(seriesSelect, "Series")
      
      // Populate year dropdown
      for (let y = startYear; y <= endYear; y++) {
        const option = document.createElement('option');
        option.value = y;
        option.textContent = y;
        yearSelect.appendChild(option);
      }
      yearSelect.removeAttribute('disabled');
    } catch (error) {
      responseContent.textContent = 'Error: ' + error.message;
      console.error('Error fetching year range:', error);
    }
  });

  // Handle Year selection -> Load Models
  yearSelect.addEventListener('change', async (event) => {
    event.preventDefault();

    const selectedYear = yearSelect.value;
    const selectedMake = makeSelect.value;
    if (!selectedYear || !selectedMake) return;

    try {
      const url = `${BASE_URL}api/models?VehicleMakeIds=${selectedMake}&Year=${selectedYear}`;
      const data = await fetchWithToken(url);
      
      // remove elements in the selects
      removeElements(modelSelect, "Model")
      removeElements(seriesSelect, "Series")
      
      populateDropdown(modelSelect, data.Items, "Model");
      modelSelect.removeAttribute('disabled');
    } catch (error) {
      responseContent.textContent = 'Error: ' + error.message;
      console.error('Error fetching models:', error);
    }
  });

  // Handle Model selection -> Load Series
  modelSelect.addEventListener('change', async (event) => {
    event.preventDefault();

    const selectedYear = yearSelect.value;
    const selectedModel = modelSelect.value;
    if (!selectedYear || !selectedModel) return;

    try {
      const url = `${BASE_URL}api/series?ModelId=${selectedModel}&Year=${selectedYear}`;
      const data = await fetchWithToken(url);
      
      // remove elements in the selects
      removeElements(seriesSelect, "Series")
      
      // If you need custom text formatting for the Name, do it here
      populateDropdown(seriesSelect, data.Items, "Series", 'Id', 'Name', true);
      seriesSelect.removeAttribute('disabled');
    } catch (error) {
      responseContent.textContent = 'Error: ' + error.message;
      console.error('Error fetching series:', error);
    }
  });

  seriesSelect.addEventListener("change", () => {
    event.preventDefault()
    tyreVehicleButton.disabled = false
  })

  // Handle Vehicle Detail Form Submission
  if (vehicleDetailForm) {
    vehicleDetailForm.addEventListener('submit', async (event) => {
      event.preventDefault();

      loaderIconVehicle.style.display = 'block'
      findTyreTextVehicle.style.display = 'none'
      const vehicleId = seriesSelect.value;
      if (!vehicleId) {
        alert('Please select a series.');
        return;
      }

      try {
        const url = `${BASE_URL}api/vehicles/${vehicleId}/tyres`
        const data = await fetchWithToken(url);
        const vehicleResult = data?.vehicleResult;
        const tyrePatternsResult = data?.tyrePatternsResult;

        let tyreSizes = [];
        let sectionWidths = [];
        let aspectRatios = [];
        let rimDiameters = [];

        const vehicleName = vehicleResult.Name || '';
        const vehicleYear = vehicleResult.Year || '';
        const tyreDescription = vehicleResult?.OEFitmentData?.FrontTyres?.Description || '';
        const tyreDescriptionRear = vehicleResult?.OEFitmentData?.RearTyres?.Description || '';
        const frontLoadIndex = vehicleResult?.OEFitmentData?.FrontTyres?.LoadIndex || '';
        const rearLoadIndex = vehicleResult?.OEFitmentData?.RearTyres?.LoadIndex || '';
        const frontSpeedIndex = vehicleResult?.OEFitmentData?.FrontTyres?.SpeedIndex || '';
        const rearSpeedIndex = vehicleResult?.OEFitmentData?.RearTyres?.SpeedIndex || '';
        const runFlat = vehicleResult?.OEFitmentData?.RunFlat === true ? 1 : 0;
        const mixedTyreSize =
        vehicleResult?.OEFitmentData?.FrontTyres?.Description !== vehicleResult?.OEFitmentData?.RearTyres?.Description;

        const loadIndexes = getLoadIndexesFrom(frontLoadIndex, rearLoadIndex);
        const loadIndexesString = loadIndexes.join(",");

        const speedIndexes = getSpeedIndexesFrom(frontSpeedIndex, rearSpeedIndex);
        const speedIndexesString = speedIndexes.join(",");

        rimDiameters.push(vehicleResult?.OEFitmentData?.FrontTyres?.RimDiameter);
        rimDiameters.push(vehicleResult?.OEFitmentData?.RearTyres?.RimDiameter);

        sectionWidths.push(vehicleResult?.OEFitmentData?.FrontTyres?.SectionWidth);
        sectionWidths.push(vehicleResult?.OEFitmentData?.RearTyres?.SectionWidth);

        aspectRatios.push(vehicleResult?.OEFitmentData?.FrontTyres?.AspectRatio);
        aspectRatios.push(vehicleResult?.OEFitmentData?.RearTyres?.AspectRatio);
        let tyreIds = [];

        tyrePatternsResult.Items.forEach(item => {
          item.TyreFitments.forEach(fitment => {
            if (fitment?.FrontTyre?.Id) tyreIds.push(fitment?.FrontTyre?.Id)
            if (fitment?.RearTyre?.Id) tyreIds.push(fitment?.RearTyre?.Id)

            if (fitment?.FrontTyre?.Size?.Description) sectionWidths.push(fitment?.FrontTyre?.Size?.SectionWidth)
            if (fitment?.RearTyre?.Size?.SectionWidth) sectionWidths.push(fitment.RearTyre?.Size?.SectionWidth)

            if (fitment.FrontTyre?.Size?.AspectRatio) aspectRatios.push(fitment?.FrontTyre?.Size?.AspectRatio)
            if (fitment.RearTyre?.Size?.AspectRatio) aspectRatios.push(fitment?.RearTyre?.Size?.AspectRatio)

            if (fitment.FrontTyre?.Size?.RimDiameter) rimDiameters.push(fitment?.FrontTyre?.Size?.RimDiameter)
            if (fitment.RearTyre?.Size?.RimDiameter) rimDiameters.push(fitment.RearTyre?.Size?.RimDiameter)

            if (fitment.FrontTyre?.Description) tyreSizes.push(fitment.FrontTyre?.Description);
            if (fitment.RearTyre?.Description) tyreSizes.push(fitment.RearTyre?.Description);
          });
        });
        
        const uniqueTyreIds = [...new Set(tyreIds)];
        const uniqueTyreSizes = [...new Set(tyreSizes)];
        const uniqueSectionWidths = [...new Set(sectionWidths)];
        const uniqueAspectRatios = [...new Set(aspectRatios)];
        const uniqueRimDiameters = [...new Set(rimDiameters)];

        const tyreIdsString = uniqueTyreIds.join(" OR ");
        const tyreSizesString = uniqueTyreSizes.join(' OR ');
        const sectionWidthsString = uniqueSectionWidths.join(',');
        const aspectRatiosString = uniqueAspectRatios.join(',');
        const rimDiametersString = uniqueRimDiameters.join(',');
        
        redirectToSearch(vehicleName, vehicleId, tyreDescription,tyreDescriptionRear, runFlat, mixedTyreSize, vehicleYear, tyreSizesString, sectionWidthsString, aspectRatiosString, rimDiametersString, loadIndexesString, speedIndexes, tyreIdsString);
      

      } catch (error) {
        responseContent.textContent = 'Error: ' + error.message;
        console.error('Error fetching vehicle details:', error);
      }
    });
  }
  
  // fetch section widths
  tyreSize.addEventListener('click', async(event) => {
    event.preventDefault();
    try {
      // Fetch section widths
      const data = await fetchWithToken(SECTION_WIDTHS_API_URL);
      const items = data.Items

      items.forEach(item => {
        const option = document.createElement('option');
        option.value = item;
        option.textContent = item;
        sectionWidthSelect.appendChild(option);
      });
      // Remove disabled if you had it initially set
      sectionWidthSelect.removeAttribute('disabled');
    } catch (error) {
      responseContent.textContent = 'Error: ' + error.message;
      console.error('Error fetching section widths:', error);
    }
  })
  

  // Handle Section Width selection -> Load Aspect Ratios
  sectionWidthSelect.addEventListener('change', async (event) => {
    event.preventDefault();

    // Clear the aspect ratio dropdown
    aspectRatioSelect.innerHTML = '';
    aspectRatioSelect.innerHTML = '<option value="" disabled selected hidden>Select Aspect Ratio</option>';
    rimDiameterSelect.innerHTML = '';
    rimDiameterSelect.innerHTML = '<option value="" disabled selected hidden>Select Rim Diameter</option>';
    // Disable the dropdown until we have new data
    aspectRatioSelect.setAttribute('disabled', true);
    rimDiameterSelect.setAttribute('disabled', true);

    const selectedSectionWidth = sectionWidthSelect.value;
    if (!selectedSectionWidth) return; // If no width selected, do nothing

    try {
      // Construct the URL for aspect ratios
      const aspectRatioSelectUrl = `${BASE_URL}api/tyres/sizes/aspect_ratios?SectionWidth=${encodeURIComponent(selectedSectionWidth)}`;

      // Fetch the data using the existing fetchWithToken function
      const data = await fetchWithToken(aspectRatioSelectUrl);

      // Populate aspectRatioSelect dropdown
      if (!data.Items || data.Items.length === 0) {
        const optionNone = document.createElement('option');
        optionNone.value = 'R';
        optionNone.textContent = 'R';
        aspectRatioSelect.appendChild(optionNone);
      } else {
        // Otherwise populate the aspectRatioSelect dropdown
        data.Items.forEach(item => {
          const option = document.createElement('option');
          option.value = item;
          option.textContent = item;
          aspectRatioSelect.appendChild(option);
        });
        const optionNone = document.createElement('option');
        optionNone.value = 'R';
        optionNone.textContent = 'R';
        aspectRatioSelect.appendChild(optionNone);
      }

      // Re-enable the dropdown
      aspectRatioSelect.removeAttribute('disabled');

    } catch (error) {
      responseContent.textContent = 'Error: ' + error.message;
      console.error('Error fetching aspect ratios:', error);
    }
  });



 // Handle Aspect Ratios selection -> Load Rim Diameter
  aspectRatioSelect.addEventListener('change', async (event) => {
    event.preventDefault();

    // Clear and disable the Rim Diameter dropdown initially
    rimDiameterSelect.innerHTML = '';
    rimDiameterSelect.innerHTML = '<option value="" disabled selected hidden>Select Rim Diameter</option>';
    rimDiameterSelect.setAttribute('disabled', true);

    const selectedSectionWidth = sectionWidthSelect.value;
    const selectedAspectRatio = aspectRatioSelect.value;

    try {
      // Start building the rim diameter URL
      let rimDiameterSelectUrl = `${BASE_URL}api/tyres/sizes/rim_diameters?SectionWidth=${encodeURIComponent(selectedSectionWidth)}`;

      // If the aspect ratio is not '--', append the aspect ratio query param
      if (selectedAspectRatio !== 'R') {
        rimDiameterSelectUrl += `&AspectRatio=${encodeURIComponent(selectedAspectRatio)}`;
      }

      // Fetch the data
      const data = await fetchWithToken(rimDiameterSelectUrl);

      // Populate the Rim Diameter dropdown
      // Populate aspectRatioSelect dropdown
      if (!data.Items || data.Items.length === 0) {
        const optionNone = document.createElement('option');
        optionNone.value = 'R';
        optionNone.textContent = 'R';
        rimDiameterSelect.appendChild(optionNone);
      } else {
        // Otherwise populate the aspectRatioSelect dropdown
        data.Items.forEach(item => {
          const option = document.createElement('option');
          option.value = item;
          option.textContent = item;
          rimDiameterSelect.appendChild(option);
        });
      }

      // Re-enable the dropdown
      rimDiameterSelect.removeAttribute('disabled');
    } catch (error) {
      responseContent.textContent = 'Error: ' + error.message;
      console.error('Error fetching rim diameters:', error);
    }
  });

  rimDiameterSelect.addEventListener("change", () => {
    event.preventDefault()
    tyreSizeButton.disabled = false
  })

  if (tyreSizeForm) {
    tyreSizeForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      loaderIconSize.style.display = 'block'
      findTyreTextSize.style.display = 'none'
      const selectedSectionWidth = sectionWidthSelect.value;
      const selectedAspectRatio = aspectRatioSelect.value === "R" ? "" : aspectRatioSelect.value;
      const selectedRimDiameter = rimDiameterSelect.value === "R" ? "" : rimDiameterSelect.value;
      const searchQuery = aspectRatioSelect.value === "R" ? `tyres&${selectedSectionWidth}R${selectedRimDiameter}` : `tyres&${selectedSectionWidth}/${selectedAspectRatio}R${selectedRimDiameter}`

      window.location.href = `/search?q=${searchQuery}&filter.p.m.custom.aspect_ratio=${selectedAspectRatio}&filter.p.m.custom.rim_diameter=${selectedRimDiameter}&filter.p.m.custom.section_width=${selectedSectionWidth}`;
    })
  }
});

function getFromLocalStorageWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return null;

  try {
    const item = JSON.parse(itemStr);

    if (!item.expiry || Date.now() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }

    return item.data;
  } catch (e) {
    localStorage.removeItem(key);
    return null;
  }
}

//-----------------------------------------------End----------------------------------------------------------------------
//---------------------------- JS for the Shop Tyres & Wheels section ----------------------------------------------------
//------------------------------------------------------------------------------------------------------------------------